module.exports = __webpack_public_path__ + "img/icon5.4987057e.png";